import { render, staticRenderFns } from "./DetailsOdaStatus.vue?vue&type=template&id=53c4b532"
import script from "./DetailsOdaStatus.vue?vue&type=script&lang=ts"
export * from "./DetailsOdaStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports